import { render, staticRenderFns } from "./LPExplainVideo.vue?vue&type=template&id=29ef1d15"
import script from "./LPExplainVideo.vue?vue&type=script&lang=ts"
export * from "./LPExplainVideo.vue?vue&type=script&lang=ts"
import style0 from "./LPExplainVideo.vue?vue&type=style&index=0&id=29ef1d15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports